//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';

export default {
  name: 'SubscribeStats',
  computed: {
    subscriptionCounts() {
      return publishedContentCounts.total.subscription;
    },
    subscriptionVideoCount() {
      const count = this.subscriptionCounts.video + this.subscriptionCounts.ae + this.subscriptionCounts.pr + this.subscriptionCounts.resolve + this.subscriptionCounts.fcp;
      return renderContentCount(this, count, 1, true);
    },
    subscriptionImageCount() {
      return renderContentCount(this, this.subscriptionCounts.image, 1, true);
    },
    subscriptionMusicCount() {
      return renderContentCount(this, this.subscriptionCounts.music + this.subscriptionCounts.sfx, 1, true);
    },
  },
};
